<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild
            :settings="fields.settings"
            :container-page="fields.containerPage"
            :show-container-page="false"
            :use-background-mobile="false"
            :show-background-image="false"
          />
        </div>

        <div class="mb-4">
          <label class="label-input">Content</label>
          <div class="group-item">
            <p class="mb-2 font-weight-bold">Specification</p>
            <ckeditor :editor="editor" :config="editorConfig" v-model="fields.content" />
            <p class="mt-4 mb-2 font-weight-bold">Note</p>
            <ckeditor :editor="editor" :config="editorConfig" v-model="fields.note" />
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Image</label>
            <input type="checkbox" v-model="fields.image.show" />
          </div>
          <div class="group-item">
            <v-select
              v-model="fields.image.position"
              label="Position"
              :items="positionOptions"
              item-text="text"
              item-value="value"
            />
            <UploadImage
              :image="{ imageSrc: fields.image.src }"
              :height="`200`"
              :typeUpload="'image'"
              @callback="handleUploadImage"
              @callbackDelete="handleRemoveImage"
            />
            <v-text-field v-model="fields.image.subText" class="mt-4" label="Sub text image" hide-details />
          </div>
        </div>

        <div class="mb-4">
          <ButtonPrimary :button="fields.button" />
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update.js';
import ButtonPrimary from './common/button-primary.vue';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'furnitureshop-specification-section-editor',
  components: {
    UploadImage,
    ButtonPrimary,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 'left' },
        { text: 'Right', value: 'right' },
      ],
      fields: {
        title: 'Furnitureshop specification',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#2A2A2A',
          textColor: '#FFFFFF',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        content: '',
        note: '',
        image: {
          show: true,
          position: 'right',
          src: '',
          subText: 'Crystal Serum',
        },
        button: {
          show: false,
          backgroundColor: '#FF8100',
          color: '#FFFFFF',
          radius: 4,
          text: 'Shop Now',
          link: '#',
          iconPrefix: { show: false, src: '' },
          iconSuffix: { show: false, src: '' },
          subBtn: { show: false, text: '' },
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) this.applyExtract(newVal.sectionExtract);
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      const extractButton = extract.button || {};
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        image: { ...this.fields.image, ...(extract.image || {}) },
        button: {
          ...this.fields.button,
          ...extractButton,
          iconPrefix: { ...this.fields.button.iconPrefix, ...(extractButton.iconPrefix || {}) },
          iconSuffix: { ...this.fields.button.iconSuffix, ...(extractButton.iconSuffix || {}) },
          subBtn: { ...this.fields.button.subBtn, ...(extractButton.subBtn || {}) },
        },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const html = updateHtmlFromData.sectionFurnitureshopSpecification(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', { ...this.sectionEditor.section, title: this.fields.title, html });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.image.src = (obj && obj.imageSrc) || '';
    },
    handleRemoveImage() {
      this.fields.image.src = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  display: block;
  margin-bottom: 10px;
  color: #000;
  font-size: 18px !important;
  font-weight: 500;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
.footer-modal {
  position: sticky;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding: 0 16px;
  background-color: #fff;
  box-shadow: 0 0 12px #0000000f;
}
::v-deep .ck-editor__editable_inline {
  min-height: 120px !important;
}
</style>
